import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ 
  contact, 
  onConfirm, 
  onCancel, 
  isDeleting = false 
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-300 p-4">
      <div className="bg-surface rounded-lg shadow-modal max-w-md w-full">
        {/* Header */}
        <div className="p-6 pb-4">
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-12 h-12 bg-error/10 rounded-full flex items-center justify-center">
              <Icon name="AlertTriangle" size={24} className="text-error" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-text-primary">
                Delete Contact
              </h3>
              <p className="text-sm text-text-secondary">
                This action cannot be undone
              </p>
            </div>
          </div>

          {/* Contact Info */}
          <div className="flex items-center space-x-3 p-3 bg-muted/50 rounded-lg border border-border">
            <div className="w-10 h-10 bg-muted rounded-full flex items-center justify-center flex-shrink-0">
              {contact?.avatar ? (
                <img 
                  src={contact?.avatar} 
                  alt={contact?.name}
                  className="w-full h-full rounded-full object-cover"
                />
              ) : (
                <Icon name="User" size={20} className="text-text-secondary" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-medium text-text-primary truncate">
                {contact?.name}
              </div>
              <div className="text-sm text-text-secondary truncate">
                {contact?.email || contact?.phone || contact?.company}
              </div>
            </div>
          </div>
        </div>

        {/* Warning Message */}
        <div className="px-6 pb-4">
          <div className="bg-error/5 border border-error/20 rounded-lg p-4">
            <div className="flex items-start space-x-3">
              <Icon name="AlertCircle" size={20} className="text-error flex-shrink-0 mt-0.5" />
              <div className="text-sm">
                <p className="text-text-primary font-medium mb-1">
                  Are you sure you want to delete this contact?
                </p>
                <p className="text-text-secondary">
                  This will permanently remove:
                </p>
                <ul className="mt-2 space-y-1 text-text-secondary">
                  <li className="flex items-center space-x-2">
                    <Icon name="User" size={14} />
                    <span>Contact information and details</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="MessageSquare" size={14} />
                    <span>Message history and conversations</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="FileText" size={14} />
                    <span>Notes and personal observations</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="Calendar" size={14} />
                    <span>Birthday reminders and events</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-end space-x-3 p-6 pt-4 border-t border-border">
          <Button
            variant="outline"
            onClick={onCancel}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          
          <Button
            variant="destructive"
            onClick={onConfirm}
            loading={isDeleting}
            iconName="Trash2"
            iconPosition="left"
          >
            {isDeleting ? 'Deleting...' : 'Delete Contact'}
          </Button>
        </div>

        {/* Alternative Actions */}
        <div className="px-6 pb-6">
          <div className="text-center">
            <p className="text-sm text-text-secondary mb-2">
              Don't want to delete? Consider these alternatives:
            </p>
            <div className="flex justify-center space-x-2">
              <Button
                variant="ghost"
                size="sm"
                iconName="Archive"
                iconPosition="left"
                onClick={() => {}}
              >
                Archive Instead
              </Button>
              
              <Button
                variant="ghost"
                size="sm"
                iconName="Edit"
                iconPosition="left"
                onClick={() => {}}
              >
                Edit Contact
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;